export * from './components/register/register.component';
export * from './components/forgot-password/forgot-password.component';
